import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  FormGroup,
  CustomInput,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Tooltip,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import moment from 'moment';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageGallery from '../../propinfo/gallery/index';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  gAPI_Internal_Property_By_Id,
  API_MEETING_ROOMS,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import CopyToClipboard from 'react-copy-to-clipboard';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Validation from '../../../../../components/Validation';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const Mins = [
  30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 480,
  510, 540, 570, 600,
];

const Pax = [10, 40, 70, 100, 130, 160, 190, 220, 250, 280, 310, 340, 370, 400];

const Hours = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24,
];

const noticeCount = [6, 12, 18, 24, 30, 36, 42, 48];

const bookingOptionList = [
  { label: 'Auto based on min and max booking time ', value: '0', key: 0 },
  { label: 'Half day booking', value: '1', key: 1 },
  { label: 'Full day booking', value: '2', key: 2 },
  { label: 'Multi-day booking', value: '3', key: 3 },
];

function Form({
  visible,
  toggle,
  formLabel,
  propertyId,
  locale,
  id,
  Load,
  currency,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const currencyFormat = (currency, value) =>
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    }).format(value);
  const handleCurrency = (currency) => {
    try {
      if (currency === 'AUD') {
        currency = currencyFormat('AUD', 0)
          .replace(/[A-Za-z]/g, '')
          .charAt(currencyFormat('AUD', 0).indexOf('$') - 1);
        return currency;
      } else if (currency === 'NZD') {
        currency = currencyFormat('NZD', 0)
          .replace(/[A-Za-z]/g, '')
          .charAt(currencyFormat('NZD', 0).indexOf('$') - 2);
        return currency;
      } else if (currency === 'PHP') {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, '')
          .substring(0, 1);
        return currency;
      } else if (currency === 'EUR') {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, '')
          .substring(0, 1);
        return currency;
      } else if (currency === 'MYR') return 'RM';
      else if (currency === 'ISK') return 'kr';
      else if (currency === 'MYR') return 'RM';
      else if (currency === 'ISK') return 'kr';
      else if (currency === 'AED') {
        return 'فلس';
      } else {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, '')
          .substring(0, 1);
        return currency;
      }
    } catch {
      currency = currencyFormat('NZD', 0)
        .replace(/[A-Za-z]/g, '')
        .charAt(currencyFormat('NZD', 0).indexOf('$') - 2);
      return currency;
    }
  };
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0,
  });
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [error, seterror] = useState(false);
  const [priceToolTip, setPriceToolTip] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  let [roomData, setRoomData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    name: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    introduction: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    details: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    conditions: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    instruction: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    images: [],
    bufferTime: 30,
    noticePeriod: 1,
    availaibilityStartTime: 1,
    availaibilityEndTime: 1,
    minimumPax: 0,
    maximumPax: 0,
    minimumBookingTime: 0,
    maximumBookingTime: 0,
    availabilityCount: 0,
    status: 'Active',
    displayPrice: false,
    displayOrder: 0,
    priceStart: 0,
    priceEnd: 0,
    taxIncluded: true,
    bookingOptions: [],
    spacePriceOptions: [
      {
        name: '',
        price: 0,
      },
    ],
  });
  const [bookingOptions, setBookingOptions] = useState(bookingOptionList);

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_MEETING_ROOMS}?id=${id}`,
      }).then((result) => {
        console.log(result);
        var selectedGuestLifeCycle = [];
        if (
          result.data.bookingOptions !== null &&
          result.data.bookingOptions.length > 0
        ) {
          selectedGuestLifeCycle = bookingOptionList.map((elem) => {
            var exist = result.data.bookingOptions.filter(
              (item) => item === elem.value
            );
            if (exist.length > 0) {
              elem.checked = true;
            } else {
              elem.checked = false;
            }
            return {
              ...elem,
            };
          });
          setBookingOptions(selectedGuestLifeCycle);
        } else {
          selectedGuestLifeCycle = bookingOptionList.map((elem) => {
            if (elem.checked) {
              elem.checked = false;
            }
            return { ...elem };
          });
          setBookingOptions(selectedGuestLifeCycle);
        }
        setRoomData(result.data);
      });
    }
  }, [id]);

  const handleAddSpacePriceOptions = () => {
    let lst = [...roomData.spacePriceOptions];
    lst.push({
      name: '',
      price: 0,
    });
    setRoomData({ ...roomData, spacePriceOptions: lst });
  };

  const handleRemoveSpacePriceOptions = (value) => {
    let lst = [...roomData.spacePriceOptions];
    lst = lst.filter((f, index) => index !== value);
    setRoomData({ ...roomData, spacePriceOptions: lst });
  };

  const handleSpacePriceOptionChange = (e, index) => {
    let lst = [...roomData.spacePriceOptions];
    lst[index][e.target.name] = e.target.value;
    setRoomData({ ...roomData, spacePriceOptions: lst });
  };

  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    }).then((res) => {
      setPropertyData(res.data);
    });
  };

  const handleChangeIntroductionArr = (e) => {
    if (roomData.introduction.length > 0) {
      const index = roomData.introduction.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          introduction: [...roomData.introduction, newStatement],
        });
      } else {
        let newArr = [...roomData.introduction];
        newArr[index].statement = e.target.value;
        setRoomData({
          ...roomData,
          introduction: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setRoomData({
        ...roomData,
        introduction: [...roomData.introduction, newStatement],
      });
    }
  };

  const handleChangeDetailsArr = (source, e) => {
    if (source === 'user') {
      if (roomData.details.length > 0) {
        const index = roomData.details.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setRoomData({
            ...roomData,
            details: [...roomData.details, newStatement],
          });
        } else {
          let newArr = [...roomData.details];
          newArr[index].statement = e;
          setRoomData({
            ...roomData,
            details: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          details: [...roomData.details, newStatement],
        });
      }
    }
  };

  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (roomData.conditions.length > 0) {
        const index = roomData.conditions.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setRoomData({
            ...roomData,
            conditions: [...roomData.conditions, newStatement],
          });
        } else {
          let newArr = [...roomData.conditions];
          newArr[index].statement = e;
          setRoomData({
            ...roomData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          conditions: [...roomData.conditions, newStatement],
        });
      }
    }
  };
  const handleInstructions = (source, e) => {
    if (source === 'user') {
      if (roomData.instruction.length > 0) {
        const index = roomData.instruction.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setRoomData({
            ...roomData,
            conditions: [...roomData.instruction, newStatement],
          });
        } else {
          let newArr = [...roomData.instruction];
          newArr[index].statement = e;
          setRoomData({
            ...roomData,
            instruction: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          instruction: [...roomData.instruction, newStatement],
        });
      }
    }
  };

  const handleChangeNameArr = (e) => {
    if (roomData.name.length > 0) {
      const index = roomData.name.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          name: [...roomData.name, newStatement],
        });
      } else {
        let newArr = [...roomData.name];
        newArr[index].statement = e.target.value;
        setRoomData({
          ...roomData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setRoomData({
        ...roomData,
        name: [...roomData.name, newStatement],
      });
    }
  };

  const selectedImage = (image) => {
    const newItems = [...roomData.images];
    newItems[imageIndex].url = image.src;
    setRoomData({
      ...roomData,
      images: newItems,
    });
  };
  const togglegallery = (index) => {
    setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };

  const handleSubmit = () => {
    AxiosAPI({
      method: 'post',
      url: API_MEETING_ROOMS,
      data: roomData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        toggle();
        Load();
      }
    });
  };

  const handleImageChange = (e, index) => {
    e.persist();
    const newItems = [...roomData.images];
    newItems[index][e.target.name] = e.target.value;
    setRoomData({
      ...roomData,
      images: newItems,
    });
  };
  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const deleteImage = (index) => {
    const values = [...roomData.images];
    values.splice(index, 1);
    setRoomData({ ...roomData, images: values });
  };

  const addImage = () => {
    const values = [...roomData.images];
    values.push({
      url: '',
      displayOrder: 0,
    });
    setRoomData({ ...roomData, images: values });
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleDisplayPrice = (e) => {
    setRoomData({ ...roomData, displayPrice: e.target.checked });
  };

  const handleBookingChange = (e) => {
    const values = bookingOptions.map((elem) => {
      if (elem.value === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    const lifecycleArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.value);
    setRoomData({
      ...roomData,
      bookingOptions: lifecycleArr,
    });
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        wrapClassName="modal-right"
        backdrop="static"
        style={{ maxWidth: '432px' }}
      >
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(roomData, null, 2)}</pre> */}
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Space Name<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="textarea"
                    maxLength={50}
                    value={getLocalStatement(roomData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Introduction<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(roomData.introduction)}
                    onChange={handleChangeIntroductionArr}
                    name="introduction"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Space Description<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(roomData.details)}
                    onChange={(content, delta, source) =>
                      handleChangeDetailsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="details"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Terms & Conditions<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(roomData.conditions)}
                    onChange={(content, delta, source) =>
                      handleChangeConditionsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="conditions"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Status<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={roomData.status}
                    name="status"
                    onChange={(e) =>
                      setRoomData({ ...roomData, status: e.target.value })
                    }
                  >
                    <option value="Draft">Draft</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                  <Input
                    type="number"
                    value={roomData.displayOrder}
                    name="displayOrder"
                    onChange={(e) =>
                      setRoomData({ ...roomData, displayOrder: e.target.value })
                    }
                  ></Input>
                </Colxx>
                {id !== undefined && (
                  <Fragment>
                    <Colxx sm={11} className="mb-3">
                      <Label>Space Preview </Label>
                      <Input
                        type="text"
                        value={`${process.env.REACT_APP_WEBVIEW}/spaceDetails?id=${id}`}
                        disabled
                      ></Input>
                    </Colxx>
                    <Colxx sm={1} className="mb-3">
                      <Label> </Label>
                      <CopyToClipboard
                        text={`${process.env.REACT_APP_WEBVIEW}/spaceDetails?id=${id}`}
                        onCopy={() =>
                          NotificationManager.success(
                            '',
                            'Link copied successfully',
                            300000,
                            null,
                            null,
                            'success'
                          )
                        }
                      >
                        <Button
                          size="xs"
                          style={{
                            marginTop: '10px',
                            border: '0',
                            background: 'white',
                            marginLeft: '-30px',
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            style={{ fill: 'var(--theme-color-1)' }}
                          >
                            <path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"></path>
                          </svg>
                        </Button>
                      </CopyToClipboard>
                    </Colxx>
                  </Fragment>
                )}
              </Row>
              <Row className="mb-2">
                <Colxx sm={12}>
                  <h4>Images</h4>
                </Colxx>
                <Colxx sm={12}>
                  {roomData.images.length > 0 &&
                    roomData.images.map((image, index) => (
                      <Row key={`${image}~${index}`}>
                        <Colxx sm={5} className="md-3">
                          <img
                            style={{
                              width: '100%',
                              height: '90%',
                            }}
                            alt="room image"
                            src={
                              image.url || 'https://via.placeholder.com/150/'
                            }
                          />
                        </Colxx>

                        <Colxx sm={3} className="mb-3">
                          <Label>Image Display Order</Label>
                          <Input
                            type="number"
                            name="displayOrder"
                            min={1}
                            value={image.displayOrder}
                            onChange={(event) =>
                              handleImageChange(event, index)
                            }
                          />
                        </Colxx>
                        <Colxx sm={2} className="mb-3">
                          <Label>Browse</Label>
                          <div
                            className="iconsminds-photo"
                            onClick={(event) => togglegallery(index)}
                            style={{
                              cursor: 'pointer',
                              fontSize: '28px',
                              color: '#73236b',
                            }}
                          ></div>
                        </Colxx>
                        <Colxx sm={2} className="mb-3">
                          <Label>Remove</Label>
                          <div>
                            <Button
                              onClick={() => deleteImage(index)}
                              color="secondary"
                              size="xs"
                              outline
                              style={{ margin: '6px' }}
                            >
                              -
                            </Button>
                          </div>
                        </Colxx>
                      </Row>
                    ))}
                </Colxx>

                <Button
                  onClick={addImage}
                  color="primary"
                  size="xs"
                  outline
                  style={{ margin: '6px' }}
                >
                  + Add image
                </Button>
              </Row>

              <Row>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Min Pax<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    value={roomData.minimumPax}
                    name="minimumPax"
                    onChange={(e) =>
                      setRoomData({ ...roomData, minimumPax: e.target.value })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Max Pax<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    value={roomData.maximumPax}
                    name="maximumPax"
                    onChange={(e) =>
                      setRoomData({ ...roomData, maximumPax: e.target.value })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Min Booking Time<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    min={1}
                    value={roomData.minimumBookingTime}
                    name="minimumPax"
                    onChange={(e) =>
                      setRoomData({
                        ...roomData,
                        minimumBookingTime: e.target.value,
                      })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Max Booking Time<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    min={roomData.minimumBookingTime}
                    value={roomData.maximumBookingTime}
                    name="maximumPax"
                    onChange={(e) =>
                      setRoomData({
                        ...roomData,
                        maximumBookingTime: e.target.value,
                      })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Availability Start Time
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={roomData.availaibilityStartTime}
                    name="availaibilityStartTime"
                    onChange={(e) =>
                      setRoomData({
                        ...roomData,
                        availaibilityStartTime: e.target.value,
                      })
                    }
                  >
                    {Hours.length > 0 &&
                      Hours.map((m) => (
                        <option value={m}>
                          {m}
                          {':00 '}
                          {m > 12 ? 'pm' : 'am'}
                        </option>
                      ))}
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Availability End Time
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={roomData.availaibilityEndTime}
                    name="availaibilityEndTime"
                    onChange={(e) =>
                      setRoomData({
                        ...roomData,
                        availaibilityEndTime: e.target.value,
                      })
                    }
                  >
                    {Hours.length > 0 &&
                      Hours.map((m) => (
                        <option value={m}>
                          {m}
                          {':00 '}
                          {m > 12 ? 'pm' : 'am'}
                        </option>
                      ))}
                  </Input>
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Booking Options</Label>
                  <Row>
                    {bookingOptions.map((o, index) => (
                      <Colxx sm={6}>
                        <CustomInput
                          type="checkbox"
                          id={'bookingOption_' + index}
                          value={o.value}
                          label={o.label}
                          checked={o.checked}
                          onChange={handleBookingChange}
                        />
                      </Colxx>
                    ))}
                  </Row>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Count Available<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    min={0}
                    value={roomData.availabilityCount}
                    name="availabilityCount"
                    onChange={(e) =>
                      setRoomData({
                        ...roomData,
                        availabilityCount: e.target.value,
                      })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Buffer Time Between Bookings
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={roomData.bufferTime}
                    name="noticePeriod"
                    onChange={(e) =>
                      setRoomData({ ...roomData, bufferTime: e.target.value })
                    }
                  >
                    {Mins.length > 0 &&
                      Mins.map((m) => <option value={m}>{m} mins</option>)}
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Booking Notice Period (in hrs.)
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="number"
                    value={roomData.noticePeriod}
                    min={0}
                    name="noticePeriod"
                    onChange={(e) =>
                      setRoomData({ ...roomData, noticePeriod: e.target.value })
                    }
                  ></Input>
                </Colxx>
                <Colxx sm={12}>
                  <Label className="mt-3"></Label>
                  <CustomInput
                    type="checkbox"
                    id="offerDiscount"
                    label="Display Price"
                    checked={roomData.displayPrice}
                    onChange={handleDisplayPrice}
                  />
                </Colxx>{' '}
                {roomData.displayPrice === true && (
                  <Fragment>
                    <Colxx sm={12}>
                      <Label className="mt-3">
                        Price Range{' '}
                        <i
                          className="demo-icon simple-icon-info"
                          id="pricetip"
                        ></i>{' '}
                      </Label>
                      <Tooltip
                        placement="right"
                        isOpen={priceToolTip}
                        target="pricetip"
                        toggle={() => setPriceToolTip(!priceToolTip)}
                      >
                        You can chose your single price or a range. Usually
                        range is useful if price is not certain and depends on
                        the specific needs.
                      </Tooltip>
                    </Colxx>
                    <Colxx sm={5} className="mb-3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          {handleCurrency(currency)}
                        </InputGroupAddon>
                        <Input
                          required
                          name="priceStart"
                          type="number"
                          min="0"
                          value={roomData.priceStart}
                          onChange={(e) =>
                            setRoomData({
                              ...roomData,
                              priceStart: e.target.value,
                            })
                          }
                        />
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={2} className="mb-3 mt-2">
                      to
                    </Colxx>
                    <Colxx sm={5} className="mb-3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          {handleCurrency(currency)}
                        </InputGroupAddon>
                        <Input
                          required
                          name="priceEnd"
                          type="number"
                          min="0"
                          value={roomData.priceEnd}
                          onChange={(e) =>
                            setRoomData({
                              ...roomData,
                              priceEnd: e.target.value,
                            })
                          }
                        />
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={12} className="mb-3">
                      <Label className="mt-3">Tax Included in Price? </Label>
                      <Input
                        name="taxIncluded"
                        type="select"
                        onChange={(e) =>
                          setRoomData({
                            ...roomData,
                            taxIncluded: e.target.value,
                          })
                        }
                        value={roomData.taxIncluded}
                      >
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </Input>
                    </Colxx>
                  </Fragment>
                )}
                <Colxx sm={12} className="mb-3">
                  <b className="mb-2">Space Price Options</b>
                  {roomData.spacePriceOptions != null &&
                    roomData.spacePriceOptions.length > 0 &&
                    roomData.spacePriceOptions.map((m, index) => (
                      <Row>
                        <Colxx sm={5} className="mb-3 mt-2">
                          <Label>Name</Label>
                          <InputGroup>
                            <Input
                              required
                              name="name"
                              type="text"
                              value={m.name}
                              onChange={(e) =>
                                handleSpacePriceOptionChange(e, index)
                              }
                            />
                          </InputGroup>
                        </Colxx>
                        <Colxx sm={5} className="mb-3 mt-2">
                          <Label>Price</Label>
                          <InputGroup>
                            <Input
                              required
                              name="price"
                              type="number"
                              min="0"
                              value={m.price}
                              onChange={(e) =>
                                handleSpacePriceOptionChange(e, index)
                              }
                            />
                          </InputGroup>
                        </Colxx>
                        <Colxx sm={2} className="mb-3 mt-4">
                          <Button
                            size="xs"
                            style={{ color: 'red', borderColor: 'red' }}
                            outline
                            onClick={() => handleRemoveSpacePriceOptions(index)}
                          >
                            X
                          </Button>
                        </Colxx>
                      </Row>
                    ))}
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Button
                    size="xs"
                    color="primary"
                    outline
                    onClick={handleAddSpacePriceOptions}
                  >
                    Add option
                  </Button>
                </Colxx>
              </Row>
            </Colxx>
            {ImageGalleryButton()}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleSubmit()}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default connect(mapStateToProps)(Form);
